<template>
    <div>
        <data-loader v-if="isLoading == 1"></data-loader>
        <transition name="fade">
            <t-modal
                name="read-terms-modal"
                @before-open="onBeforeOpen"
                @open="onOpen"
                @closed="onClose"
                header=""
            >
                <template #header> Read Terms and Conditions </template>
                <template #default><slot></slot></template>
            </t-modal>
        </transition>
    </div>
</template>

<script>
function initialState() {
    return {
        isLoading: 0,
    };
}
export default {
    props: {},
    data() {
        return initialState();
    },
    mounted() {},
    methods: {
        onBeforeOpen({ params, cancel }) {
            //get the session
        },
        onOpen() {},
        onClose() {},
    },

    computed: {},
};
</script>

<style scoped></style>
